import { useEffect, useState } from 'react';

const error: string = 'You must enter at least two characters';
const emptyString: string = '';

export type TextFilterProps = {
	onKeyWordFilterChange: (value: string) => void;
	onErrorMessageChange: (value: string) => void;
	handleAnswered: (value: string) => Promise<void>;
	handleResetFilter: () => Promise<void>;
	errorMessage: string;
	keywordFilterActive: boolean;
	keyWordFilterVal: string;
};

const TextFilter: React.FC<TextFilterProps> = ({
	onKeyWordFilterChange,
	onErrorMessageChange,
	handleAnswered,
	handleResetFilter,
	errorMessage,
	keywordFilterActive,
	keyWordFilterVal,
}) => {
	const [keyWordFilter, setKeyWordFilter] = useState<string>('');

	useEffect(() => {
		setKeyWordFilter(keyWordFilterVal);
	}, [keyWordFilterVal]);

	const isInputEmpty = (): boolean => {
		return keyWordFilter.length === 0;
	};

	const isErrorMessageVisible = (): boolean => {
		return errorMessage.length > 0;
	};

	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setKeyWordFilter(event.target.value);
	};

	const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
		if (event.key === 'Enter' && !isInputEmpty()) {
			if (keyWordFilter?.length < 2) {
				onErrorMessageChange(error);
			} else {
				onKeyWordFilterChange(keyWordFilter);
				onErrorMessageChange(emptyString);
				handleAnswered(keyWordFilter);
			}
		}
	};

	const handleAjax = () => {
		setKeyWordFilter('');
		onErrorMessageChange(emptyString);
		onKeyWordFilterChange(emptyString);
		handleResetFilter();
	};

	return (
		<>
			<div className="content row searchField">
				<div className="col-12 searchTextFieldWrapper">
					<input
						type="text"
						id="searchTextField"
						placeholder={'Enter Fund Name or Ticker'}
						className="searchTextField"
						aria-describedby="search-error"
						aria-label="Enter Fund Name or Ticker"
						value={keyWordFilter}
						onChange={handleInputChange}
						onKeyUp={handleKeyDown}
					/>

					{!keywordFilterActive &&
					isInputEmpty() &&
					!isErrorMessageVisible() ? (
						<button
							aria-controls="searchTextField"
							aria-label={'Search'}
							className="searchIcon"
							tabIndex={0}
							type="submit"
						>
							<i
								id="searchIcon"
								className="fa fa-search iconField outline-none"
							/>
						</button>
					) : (
						<button
							aria-controls="searchTextField"
							aria-label={'Remove input'}
							className="searchIcon"
							tabIndex={0}
							type="submit"
							onClick={handleAjax}
						>
							<i
								id="searchIcon"
								className="fa fa-times iconField outline-none close"
							/>
						</button>
					)}
				</div>
				<div className="col-12">
					<hr
						className="horizontal-line"
						id="searchTextLine"
						aria-hidden="true"
					/>
					<div id="errorMessageDiv" hidden={errorMessage.length === 0}>
						<span>
							<i
								id="errorIcon"
								className="errorIcon fas fa-exclamation-triangle outline-none"
							></i>
						</span>
						<span className="errorMessage" id="search-error" aria-live="polite">
							{errorMessage}
						</span>
					</div>
				</div>
			</div>
		</>
	);
};

export default TextFilter;
